import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AlertService } from '../../services/alert/alert-service.service';
import { Alert } from '../../interfaces/alert.interface';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: true,
  imports: [],
})
export class AlertComponent implements OnInit {
  private readonly _alert = inject(AlertService);
  private readonly destroyRef = inject(DestroyRef);

  alert!: Alert;
  isShow: boolean = false;

  ngOnInit(): void {
    this.alert = this._alert.data;

    this._alert.isShow$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (isShow: boolean) => {
        this.alert = this._alert.data;
        this.isShow = isShow;
      },
    });
  }

  accept(): void {
    this._alert.hideAlert();
    this.alert?.onAccept?.();
  }

  cancel(): void {
    this._alert.hideAlert();
    this.alert?.onCancel?.();
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      this.accept();
    }
  }
}
